import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetStampCacheListApi } from '@/apis/basics/stamps.api';

const { wsCache } = useCache();
const StampCacheKey = 'StampCacheList';

export const useStampStore = defineStore('stamp_maps', {
	state: (): any => ({
		stampList: [] as any[],
		stampMap: {} as any,
	}),
	getters: {
		getName(stampId: string) {
			this.stampMap.get(stampId) ?? '--';
		},
	},
	actions: {
		async setStampMaps() {
			let stampList = wsCache.get(StampCacheKey);

			if (!stampList) {
				stampList = await this.getStampList();
			}

			/* 设置下拉数据列表(生效的数据) */
			this.stampList = stampList
				.filter((item: any) => item.is_enabled == 'Y')
				.map((stamp: any) => {
					return { value: stamp.id, label: `${stamp.stamp_name}(${stamp.stamp_no})` };
				});

			/* 设置映射 */
			const stampMap = new Map();
			stampList.forEach((stemp: any) => {
				stampMap.set(stemp.id, stemp.stamp_name);
			});

			this.stampMap = stampMap;
		},
		getStampList() {
			return new Promise((resolve) => {
				GetStampCacheListApi().then((res: any) => {
					const stampList = res.data || [];
					wsCache.set(StampCacheKey, stampList);
					resolve(stampList);
				});
			});
		},
	},
});
